module.exports = __webpack_public_path__ + "static/media/ETHAX_Swap_Staking_Comprehensive_SmartContract_Audit_SOKEN.031ecb92.pdf";